module.exports = __webpack_public_path__ + "static/media/spanish-imperative-table2.3e0dd51d.PNG";